import { Link } from 'react-router-dom';

const NriForeignNationalsSection = () => {
  return (
    <div className="container">
      <div className="row forgin-asiatic">
        <div className="col-md-12">

          <p className="section-description">
            Experience the Asiatic's NRI Corner.
            We offer complete range of solutions to NRI investors & foreign nationals in the Indian Stock markets. As a client of Asiatic's, you are entitled to the following privileges:
          </p>
          
          <div className="privileges-list">
            <div className="privilege-item">
              <span className="privilege-icon">📋</span>
              <div className="privilege-content">
                <h5>Registering for PAN Card</h5>
                <p>Documents to apply for a pan-card if you do not possess one</p>
              </div>
            </div>
            
            <div className="privilege-item">
              <span className="privilege-icon">💼</span>
              <div className="privilege-content">
                <h5>Opening Trading Account</h5>
                <p>You can invest and trade in Equities and Derivatives listed on NSE and BSE. You can also invest in Mutual Funds and IPOs from this account.</p>
              </div>
            </div>
            
            <div className="privilege-item">
              <span className="privilege-icon">📊</span>
              <div className="privilege-content">
                <h5>Setting up of Demat Account</h5>
                <p>All investments in shares are held electronically in your demat account. Physical shares if any can be converted into electronic form and transferred to this account.</p>
              </div>
            </div>
            
            <div className="privilege-item">
              <span className="privilege-icon">🏦</span>
              <div className="privilege-content">
                <h5>Opening Bank Account</h5>
                <p>We are associated with HDFC, ICICI and Axis Bank. All your investments in India will be routed through the designated Bank Account.</p>
              </div>
            </div>
            
            <div className="privilege-item">
              <span className="privilege-icon">🤝</span>
              <div className="privilege-content">
                <h5>Assisted Trading</h5>
                <p>We offer Assisted Trading through our team of dealers specially designed for NRI customers</p>
              </div>
            </div>
          </div>
          
          <div className="contact-cta">
            <p className="cta-text">
              Fill out the following information if you want us to get in touch with you.
            </p>
          </div>
        </div>
      </div>
      
      <div className="clearfix"></div>
      
      <div className="nri-faq-link">
        <Link to="/nri-faq" className="button-download">
          NRI FAQ
        </Link>
      </div>

      <style jsx>{`
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .forgin-asiatic {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border-radius: 20px;
          padding: 3rem 2.5rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin: 2rem 0;
          border: 1px solid #e9ecef;
        }



        .section-description {
          color: #6c757d;
          font-size: 1.1rem;
          line-height: 1.6;
          text-align: center;
          margin-bottom: 2.5rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .privileges-list {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          margin-bottom: 2.5rem;
        }

        .privilege-item {
          display: flex;
          align-items: flex-start;
          gap: 1.5rem;
          padding: 1.5rem;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border-left: 4px solid transparent;
        }

        .privilege-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          border-left-color: #007bff;
        }

        .privilege-icon {
          font-size: 2rem;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: transform 0.3s ease;
        }

        .privilege-item:hover .privilege-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .privilege-content {
          flex: 1;
        }

        .privilege-content h5 {
          color: #2c3e50;
          font-weight: 600;
          font-size: 1.3rem;
          margin-bottom: 0.5rem;
        }

        .privilege-content p {
          color: #6c757d;
          line-height: 1.6;
          margin: 0;
          font-size: 1rem;
        }

        .contact-cta {
          text-align: center;
          padding: 1.5rem;
          background: linear-gradient(135deg, #e8f4ff 0%, #f0f8ff 100%);
          border-radius: 12px;
          border: 2px dashed #007bff;
          margin-top: 1rem;
        }

        .cta-text {
          color: #2c3e50;
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0;
          font-style: italic;
        }

        .nri-faq-link {
          text-align: center;
          margin: 2rem 0;
        }

        .button-download {
          display: inline-block;
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          color: white;
          text-decoration: none;
          padding: 10px 35px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
          border: none;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .button-download::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s ease;
        }

        .button-download:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
          text-decoration: none;
          color: white;
        }

        .button-download:hover::before {
          left: 100%;
        }

        .clearfix {
          clear: both;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .forgin-asiatic {
            padding: 2rem 1.5rem;
            margin: 1rem 0;
          }

       

          .section-description {
            font-size: 1rem;
            margin-bottom: 2rem;
          }

          .privilege-item {
            flex-direction: column;
            text-align: center;
            gap: 1rem;
            padding: 1.25rem;
          }

          .privilege-icon {
            width: 50px;
            height: 50px;
            font-size: 1.5rem;
          }

          .privilege-content h5 {
            font-size: 1.2rem;
          }

          .button-download {
            padding: 12px 30px;
            font-size: 1rem;
            width: 100%;
            max-width: 200px;
          }
        }

        @media (max-width: 480px) {
          .forgin-asiatic {
            padding: 1.5rem 1rem;
          }

          .privilege-item {
            padding: 1rem;
          }

          .contact-cta {
            padding: 1rem;
          }

          .cta-text {
            font-size: 1rem;
          }
        }

        /* Animation for items */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .privilege-item {
          animation: fadeInUp 0.5s ease forwards;
        }

        .privilege-item:nth-child(1) { animation-delay: 0.1s; }
        .privilege-item:nth-child(2) { animation-delay: 0.2s; }
        .privilege-item:nth-child(3) { animation-delay: 0.3s; }
        .privilege-item:nth-child(4) { animation-delay: 0.4s; }
        .privilege-item:nth-child(5) { animation-delay: 0.5s; }
      `}</style>
    </div>
  );
};

export default NriForeignNationalsSection;